import React, { useContext, useRef, useEffect, useState } from "react";
import DynamicGrid from "../../Components/DynamicGrid/DynamicGrid";
import Heading from "../../Components/Heading/Heading";
import { APICall } from "../../Helpers/API/APICalls";
import { APICalls } from "../../Helpers/API/APICalls2";

import {
  getEngagementByLeadApi,
  TestCasesDownloadExcelTemplate,
  GetGridData,
  GetTestCaseStatus,
  GetTestCaseByID,
  UpdateTestCases,
  TestCaseInsert,
  GetDropDownList,
  getEngagementforTestCase,
  ExporttoExcelTTraceabilityTestCases,
} from "../../Helpers/API/APIEndPoints";
import { getContext, LoaderContext } from "../../Helpers/Context/Context";
import { useLocation, useNavigate } from "react-router-dom";
import SelectForm from "../../Components/SelectForm/SelectForm";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { Tooltip } from "antd";
//import {ExcelRenderer} from "react-excel-renderer";
import { LocalizationProvider } from "@mui/x-date-pickers";
import notify from "../../Helpers/ToastNotification";
import fileDownload from "js-file-download";
import "./TraceabilityMatrix.css";
import axios from "axios";
import InputForm from "../../Components/InputForm/InputForm";
// import Modal from "@mui/material/Modal";
import { Modal } from "react-bootstrap";
import { Box } from "@mui/material";
import { FaTruckMonster } from "react-icons/fa";
import { truncate } from "fs/promises";
import moment from "moment";

function TraceabilityTestCases() {
  const [testCaseGridData, setTestCaseGridData] = useState<any>([]);
  const { EmployeeId, RoleId } = getContext();
  const RoleIdArray = RoleId.split(",");
  let navigate = useNavigate();
  const [pageSize, setPageSize] = useState(10);
  const [start, setStart] = useState(0);
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [searchText, setSearchText] = useState("");
  const [count, setCount] = useState(0);
  const excelFileRef = useRef<any>();
  const [excelFileName, setExcelFileName] = useState<any>("No File Uploaded");
  const [excelFileContent, setExcelFileContent] = useState<any>("");
  const [Engagement, setEngagement] = useState<any>({});
  const [EngagementOptions, setEngagementOptions] = useState<any>([]);
  const [StatusOptions, setStatusOptions] = useState<any>([]);
  const [TestCaseStatus, setTestCaseStatus] = useState<any>({});
  const [FormErrors, setFormErrors] = useState<any>({});
  const [ModalFormErrors, setModalFormErrors] = useState<any>({});
  const [open, setOpen] = useState(false);
  const [TestcaseId, setTestcaseId] = useState(0);
  const [requirementTitle, setRequirementTitle] = useState("");
  const [PreRequisite, setPreRequisite] = useState("");
  const [Description, setDescription] = useState("");
  const [ExpectedResult, setExpectedResult] = useState("");
  const [RequirementID, setRequirementID] = useState(0);
  const [isActive, setIsActive] = useState(false);
  const { showLoader, hideLoader } = useContext(LoaderContext); //added by mahesh
  const [disabled, setDisabled] = useState(false); //added by mahesh
  const [aftererr, setAftererror] = useState(0);
  // added a new usestate for the status, Raj potdar, Date: 29-1-2024
  const [isactivestring, setIsActiveString] = useState("active");

  //let fileExtensionName;
  let formErrorObj = {};
  let modalFormErrorObj = {};
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

  // Added custom color for tooltip
  const customColors = ["#2755f3"];

  const testCaseGridDataColumns = [
    {
      name: "testcaseID",
      label: "ID",
      options: {
        display: true,
      },
    },
    // {
    //   name: "requirementId",
    //   label: "RequirementID",
    //   options: {
    //     filter: false
    //   },
    // },
    {
      name: "requirementTitle",
      label: "Requirement",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
      },
    },
    {
      name: "preRequisties",
      label: "Pre Requisties",
      options: {
        filter: false,
      },
    },
    {
      name: "description",
      label: "Description",
      options: {
        filter: false,
      },
    },
    {
      name: "expectedResult",
      label: "Expected Result",
      options: {
        filter: false,
      },
    },
    {
      name: "statusTitle",
      label: "Status",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
      },
    },
    {
      name: "isActive",
      label: "Active",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          if (value) {
            return <i className="fas fa-check"></i>;
          } else {
            return <i className="fas fa-times"></i>;
          }
        },
      },
    },
    {
      name: "",
      label: "Action",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          let id = tableMeta.tableData[tableMeta.rowIndex].id;
          let testcaseID = tableMeta.tableData[tableMeta.rowIndex].testcaseID;
          let statusTestcase =
            tableMeta.tableData[tableMeta.rowIndex].statusTitle;
          if (statusTestcase !== "Passed UAT Testing") {
            return (
              <>
                <Tooltip title="Edit" color={customColors[0]}>
                  <a
                    onClick={() => handleOpen(testcaseID)}
                    className="action_icon"
                  >
                    <i className="fa fa-pencil" aria-hidden="true"></i>
                  </a>
                </Tooltip>
              </>
            );
          }
        },
      },
    },
  ];

  useEffect(() => {
    localStorage.clear(); //deepak gupta
    (async () => {
      await getEngagementbyLeads();
    })();
  }, []);
  useEffect(() => {
    (async () => {
      await getTestCasesGridDataApi();
    })();
    // added a new parameter isactivestring, Raj potdar, Date: 29-11-2024
  }, [
    Engagement,
    start,
    sortColumn,
    sortDirection,
    searchText,
    aftererr,
    isactivestring,
  ]);
  const getTestCaseById = async (id: any) => {
    await getTestCaseStatus();
    await getTestCases(id);
  };
  const modalSubmitValidation = async () => {
    await setModalFormErrors({});
    if (requirementTitle === "") {
      setModalFormErrors((preState) => ({
        ...preState,
        ["requirementTitle_isEmpty"]: "Requirement Title can't be empty",
      }));
      modalFormErrorObj["requirementTitle_isEmpty"] =
        "Requirement Title can't be empty";
    }

    if (PreRequisite === "") {
      setModalFormErrors((preState) => ({
        ...preState,
        ["preRequisite_isEmpty"]: "PreRequisite can't be empty",
      }));
      modalFormErrorObj["preRequisite_isEmpty"] = "PreRequisite can't be empty";
    }
    if (Description === "") {
      setModalFormErrors((preState) => ({
        ...preState,
        ["description_isEmpty"]: "Description can't be empty",
      }));
      modalFormErrorObj["description_isEmpty"] = "Description can't be empty";
    }

    if (ExpectedResult === "") {
      setModalFormErrors((preState) => ({
        ...preState,
        ["expectedResult_isEmpty"]: "Expected Result can't be empty",
      }));
      modalFormErrorObj["expectedResult_isEmpty"] =
        "Expected Result can't be empty";
    }
  };
  const handleOpen = async (testcaseID) => {
    await getTestCaseById(testcaseID);
    setOpen(true);
  };
  const handleClose = () => setOpen(false);
  const getTestCasesGridDataApi = async () => {
    let post = {
      EngagementId: Engagement.value,
      start: start,
      pageSize: pageSize,
      sortColumn: sortColumn,
      sortDirection: sortDirection,
      searchText: searchText,
      // added a new parameter activeStatusId, Raj potdar, Date: 29-11-2024
      activeStatusId: isactivestring,
    };
    const { data } = await APICall(GetGridData, "POST", post);
    if (data) {
      // setTestCaseGridData(data.testData);
      setTestCaseGridData(data.testData);
      setCount(data.count);
    }
  };
  const getTestCases = async (id: any) => {
    let post = {
      Id: id,
    };
    const { data } = await APICall(GetTestCaseByID, "POST", post);
    if (data != undefined || data != null) {
      await data.map((tc: any) => {
        setTestcaseId(tc.id);
        setRequirementTitle(tc.requirementTitle);
        setPreRequisite(tc.preRequisties);
        setExpectedResult(tc.expectedResult);
        setDescription(tc.description);
        setIsActive(tc.isActive);
        setRequirementID(tc.requirementId);
        setTestCaseStatus({ label: tc.statusTitle, value: tc.status });
      });
    }
  };
  const getTestCaseStatus = async () => {
    const { data } = await APICall(GetTestCaseStatus, "POST");
    if (data != undefined || data != null) {
      let statusArray = [];
      await data.map((st: any) => {
        let tempObj = {
          value: st.Id,
          label: st.statusTitle,
        };
        statusArray.push(tempObj);
      });
      setStatusOptions(statusArray);
    }
  };
  const getEngagementbyLeads = async () => {
    if (RoleIdArray.includes("3") || RoleIdArray.includes("8")) {
      let postObject = {
        searchFor: "requirementEngagements",
        SearchValue: 3,
      };
      const { data } = await APICall(GetDropDownList, "POST", postObject);
      if (data) {
        let engagementArray = [];

        await data.map((engagement: any) => {
          let tempObj = {
            label: engagement.engagement,
            value: engagement.engagementID,
            //engagementId: engagement.id,
          };
          engagementArray.push(tempObj);
        });

        //  engagementArray.sort((a, b) => a.label.localeCompare(b.label));
        setEngagementOptions(engagementArray);
      }
    } else {
      var date = new Date();
      var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      let postObject = {
        EmployeeID: EmployeeId,
        fromDate: moment(firstDay).format(moment.HTML5_FMT.DATE),
        toDate: moment(lastDay).format(moment.HTML5_FMT.DATE),
      };
      const { data } = await APICall(
        getEngagementforTestCase,
        "POST",
        postObject
      );

      if (data != undefined || data != null) {
        let engagementArray = [];
        await data.map((eng: any) => {
          let tempObj = {
            value: eng.engagementId,
            label: eng.engagementName,
          };

          engagementArray.push(tempObj);
        });
        setEngagementOptions(engagementArray);
      }
    }
  };
  const options = {
    selectableRows: "none",
    count: count,
    rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: true,
    onChangeRowsPerPage: (num) => {
      //   setLimit(num);
      //   setNxtPgInfo("");
      //   setPrevPgInfo("");
      //   setIsPrevOrNext("");
    },
    onSearchChange: (searchText) => {
      if (searchText !== null) {
        setSearchText(searchText);
        setStart(0);
      } else {
        setSearchText("");
      }
    },
    onColumnSortChange: async (sortColumn, sortDirection) => {
      if (sortDirection === "asc") {
        await setSortColumn(sortColumn);
        await setSortDirection(sortDirection);
      }
      if (sortDirection === "desc") {
        await setSortColumn(sortColumn);
        await setSortDirection(sortDirection);
      }
    },
    onChangePage: async (page) => {
      setStart(page * pageSize);
    },
    // added a new function for a new filter option, Raj Potdar, Date : 29-11-2024
    customToolbar: () => {
      return (
        <FormControl sx={{ mt: 1 }}>
          <InputLabel id="demo-simple-select-helper-label">Active</InputLabel>
          <Select
            labelId="demo-simple-select-helper-label"
            id="demo-simple-select-helper"
            label="Active"
            value={isactivestring}
            onChange={handleChange}
            sx={{
              width: 80,
              height: 30, // Set the desired height
              "&:focus": { color: "success.main" }, // Change text color to green on focus
            }}
          >
            <MenuItem value={"All"}>All</MenuItem>
            <MenuItem value={"active"}>Yes</MenuItem>
            <MenuItem value={"inactive"}>No</MenuItem>
          </Select>
        </FormControl>
      );
    },
  };

  const handleChange = (event: SelectChangeEvent) => {
    setIsActiveString(event.target.value);
  };

  const selectOnChange = async (event: any, apiFieldName: any) => {
    if (apiFieldName === "engagement") {
      setEngagement(event);
      if (event && Object.keys(event).length > 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["engagement_isEmpty"]: undefined,
        }));
      } else if (!event || Object.keys(event).length === 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["engagement_isEmpty"]: "Enagagement type can not be empty",
        }));
      }
    }
    if (apiFieldName === "status") {
      setTestCaseStatus(event);
    }
    if (apiFieldName === "requirementTitle") {
      setRequirementTitle(event.target.value);
      setModalFormErrors((preState) => ({
        ...preState,
        ["requirementTitle_isEmpty"]: "",
      }));
      if (
        event.target.value == undefined ||
        event.target.value == null ||
        event.target.value == ""
      ) {
        setModalFormErrors((preState) => ({
          ...preState,
          ["requirementTitle_isEmpty"]: "Requirement Title can't be empty",
        }));
      }
    }
    if (apiFieldName === "PreRequisite") {
      setPreRequisite(event.target.value);
      setModalFormErrors((preState) => ({
        ...preState,
        ["preRequisite_isEmpty"]: "",
      }));
      if (
        event.target.value == undefined ||
        event.target.value == null ||
        event.target.value == ""
      ) {
        setModalFormErrors((preState) => ({
          ...preState,
          ["preRequisite_isEmpty"]: "preRequisite can't be empty",
        }));
      }
    }
    if (apiFieldName === "Description") {
      setDescription(event.target.value);
      setModalFormErrors((preState) => ({
        ...preState,
        ["description_isEmpty"]: "",
      }));
      if (
        event.target.value == undefined ||
        event.target.value == null ||
        event.target.value == ""
      ) {
        setModalFormErrors((preState) => ({
          ...preState,
          ["description_isEmpty"]: "Description can't be empty",
        }));
      }
    }
    if (apiFieldName === "ExpectedResult") {
      setExpectedResult(event.target.value);
      setFormErrors((preState) => ({
        ...preState,
        ["expectedResult_isEmpty"]: "",
      }));
      if (
        event.target.value == undefined ||
        event.target.value == null ||
        event.target.value == ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["expectedResult_isEmpty"]: "Expected result can not be empty",
        }));
      }
    }
  };

  const RequestExcelFileChange = () => {
    excelFileRef.current.click();

    setExcelFileName(excelFileRef.current.files[0].name);
    if (excelFileRef.current.files[0].name) {
      setFormErrors((preState) => ({
        ...preState,
        ["bulkUploadRequestExcel_isEmpty"]: undefined,
      }));
    } else if (
      excelFileRef.current.files[0].name ||
      excelFileRef.current.files[0].name === "" ||
      excelFileRef.current.files[0].name === "No File Uploaded"
    ) {
      formErrorObj["bulkUploadRequestExcel_isEmpty"] = "please upload file.";
      setFormErrors((preState) => ({
        ...preState,
        ["bulkUploadRequestExcel_isEmpty"]: "Please upload file.",
      }));
    }
  };

  const onSubmitValidation = async () => {
    await setFormErrors({});
    formErrorObj = {};
    if (!Engagement || Object.keys(Engagement).length === 0) {
      setFormErrors((preState) => ({
        ...preState,
        ["engagement_isEmpty"]: "Engagement cannot be empty",
      }));
      formErrorObj["engagement_isEmpty"] = "Engagement cannot be empty";
    }

    if (
      !excelFileName ||
      excelFileName === "" ||
      excelFileName === "No File Uploaded"
    ) {
      formErrorObj["bulkUploadRequestExcel_isEmpty"] = "please upload file.";
      setFormErrors(formErrorObj);
    }
  };

  const onClickFunction = async (action: any) => {
    if (action === "submit") {
      setDisabled(true);
      showLoader(); //added by mahesh
      await onSubmitValidation();
      const isEmpty = await Object.values(formErrorObj).every(
        (x) => x === null || x === "" || x == undefined
      );
      if (isEmpty == true) {
        setDisabled(false);
        var formdata = new FormData();

        formdata.append("file", excelFileContent);
        formdata.append("EngagementId", Engagement.value);
        formdata.append(
          "CreatedDate",
          moment(new Date()).format(moment.HTML5_FMT.DATE)
        );
        formdata.append("CreatedBy", EmployeeId);

        const { data } = await APICalls(TestCaseInsert, "POST", formdata);
        if (data != undefined || data != null) {
          if (data.responseStatus === 2) {
            var splitted = data.response.split("\n");
            const ErrorList = () => {
              return (
                <ul>
                  {splitted.map((error: string, index) => (
                    <li key={index}>{error}</li>
                  ))}
                </ul>
              );
            };
            notify(1, <ErrorList />);
            setExcelFileName("No File Uploaded");
            setExcelFileContent("");
            setAftererror(1);
          } else {
            notify(0, "Testcase Uploaded successfully");
            setExcelFileName("No File Uploaded");
            setExcelFileContent("");
            await getTestCasesGridDataApi();
          }
        }
      } else {
        setDisabled(false);
      }
      hideLoader(); //added by mahesh
    } else if (action === "Download") {
      if (!Engagement || Object.keys(Engagement).length === 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["engagement_isEmpty"]: "Engagement can not be empty",
        }));
        formErrorObj["engagement_isEmpty"] = "Engagement can not be empty";
      } else {
        axios
          .request({
            responseType: "blob",
            method: "POST",

            //data: Response,
            url: TestCasesDownloadExcelTemplate,
            //data:JSON,
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Content-Type": "application/json",
              "Access-Control-Allow-Headers": "*",
            },
            data: {
              EngagementId: Engagement.value,
              pageSize: count,
              activeStatusId: isactivestring,
            },
          })
          .then((response) => {
            fileDownload(response.data, Engagement.label + "TestCases.xlsx");
          })
          .catch((error) => {
            console.log(error.response.data);
          });
      }
    } else if (action == "reset") {
      reset();
    } else if (action == "submitModal") {
      showLoader(); //added by mahesh
      await modalSubmitValidation();
      const isEmpty = await Object.values(modalFormErrorObj).every(
        (x) => x === null || x === "" || x == undefined
      );
      if (isEmpty === true) {
        let submitObj = {
          Id: TestcaseId,
          PreRequisties: PreRequisite,
          Description: Description,
          ExpectedResult: ExpectedResult,
          IsActive: isActive,
          CreatedDate: new Date(),
          CreatedBy: EmployeeId,
          EngagementId: Engagement.value,
          Status: TestCaseStatus.value,
        };
        const { data } = await APICall(UpdateTestCases, "POST", submitObj);

        if (data.responseStatus === 1) {
          notify(0, data.response);
        }
        setOpen(false);
        await getTestCasesGridDataApi();
      }
      hideLoader(); //added by mahesh
    }
  };

  const reset = () => {
    setExcelFileName("No File Uploaded");
    setExcelFileContent("");
    setEngagement({});
  };
  const handleFiles = (e: any) => {
    setExcelFileName(e.target.files[0].name);
    setFormErrors((preState) => ({
      ...preState,
      ["bulkUploadRequestExcel_isEmpty"]: "",
    }));
    var f = e.target.files[0];
    setExcelFileContent(f);
    e.target.value = "";
  };
  const style = {
    position: "fixed",
    top: "10%",
    left: "10%",
    backgroundColor: "background.paper",
    zIndex: "1000",
    overflowY: "auto",
    width: "80%",
    height: "80%",
    backdrop: "static",
    boxShadow: 24,
    p: 4,
    borderRadius: 3,
  };

  // Added by Omkar
  const ExportToExcel = () => {
    debugger;
    if (!Engagement || !Engagement.value) {
      setFormErrors((prev) => ({
        ...prev,
        engagement_isEmpty: "Engagement type cannot be empty.",
      }));
      return;
    } else {
      setFormErrors((prev) => ({
        ...prev,
        engagement_isEmpty: "",
      }));
    }
    let obj = {
      EngagementId: Engagement.value,
      start: start,
      pageSize: count,
      sortColumn: sortColumn,
      sortDirection: sortDirection,
      searchText: searchText,
      activeStatusId: isactivestring,
    };

    axios
      .request({
        responseType: "blob",
        method: "POST",

        url: ExporttoExcelTTraceabilityTestCases,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "Access-Control-Allow-Headers": "*",
        },
        data: obj,
      })
      .then((response) => {
        fileDownload(response.data, "TraceabilityTestCase.xlsx");
      })
      .catch((error) => {});
  };

  return (
    <>
      <Heading title={"Test Cases"} />
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Engagement <sup>*</sup>
              </label>
              <SelectForm
                options={EngagementOptions}
                placeholder="Select"
                isDisabled={false}
                value={Engagement}
                onChange={(event) => selectOnChange(event, "engagement")}
                isMulti={false}
                noIndicator={false}
                noSeparator={false}
              />
              <p style={{ color: "red" }}>{FormErrors["engagement_isEmpty"]}</p>
            </div>
          </div>
          {Object.keys(Engagement).length > 0 && (
            <>
              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="form-group">
                  <label>
                    Upload Excel <sup>*</sup>
                  </label>
                  <div className="input-group">
                    <div className="custom-file">
                      <input
                        type="file"
                        accept=".xls,.xlsx"
                        className="custom-file-input"
                        id="file"
                        aria-describedby="inputGroupFileAddon01"
                        style={{ borderRadius: "2px" }}
                        onChange={(e) => {
                          handleFiles(e);
                        }}
                      />
                      <label
                        className="custom-file-label"
                        htmlFor="inputGroupFile01"
                      >
                        {excelFileName}
                      </label>
                    </div>
                  </div>
                  <p style={{ color: "red" }}>
                    {FormErrors["bulkUploadRequestExcel_isEmpty"]}
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <div className="d-flex gap-2 justify-content-end">
                    {/* <i
                      className="fas fa-file-excel"
                      onClick={() => ExportToExcel()}
                    >
                    Export to excel
                    // </i> */}
                   
                    <button
                      className="btn btn-export"
                      onClick={() => onClickFunction("Download")}
                    >
                      Download Template
                    </button>
                    <button
                      className="btn btn-submit"
                      onClick={() => onClickFunction("submit")}
                      disabled={disabled}
                    >
                      Upload
                    </button>
                    <button
                      className="btn btn-reset"
                      onClick={() => onClickFunction("reset")}
                    >
                      Clear
                    </button>
                  </div>
                </div>
              </div>
            </>
          )}

          <div className="col-lg-12">
            {Engagement && Engagement.value ?
              (<div className="d-flex gap-2 justify-content-end">
                 <button
                      className="btn btn-export"
                      onClick={() => ExportToExcel()}
                    >
                      Export Excel
                    </button>
                </div>
                )
                :
              <></>
            }

          </div>

          <div className="col-lg-12 mt-3">
            <DynamicGrid
              options={options}
              data={testCaseGridData}
              columns={testCaseGridDataColumns}
            />
          </div>
        </div>
      </div>

      <Modal
        show={open}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        centered
        size="lg"
        scrollable={true}
      >
        <Modal.Body>
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="form-group">
                <label>Test Case ID</label>
                <InputForm
                  isDisabled={true}
                  placeholder={""}
                  textArea={false}
                  value={TestcaseId}
                  onChange={(event) => selectOnChange(event, "TestCaseID")}
                />
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="form-group">
                <label>
                  Requirement <sup>*</sup>
                </label>
                <InputForm
                  isDisabled={true}
                  placeholder={""}
                  textArea={false}
                  value={requirementTitle}
                  onChange={(event) =>
                    selectOnChange(event, "requirementTitle")
                  }
                />
                <p style={{ color: "red" }}>
                  {ModalFormErrors["requirementTitle_isEmpty"]}
                </p>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="form-group">
                <label>
                  Pre Requisite <sup>*</sup>
                </label>
                <InputForm
                  isDisabled={false}
                  placeholder={""}
                  textArea={true}
                  value={PreRequisite}
                  rows={3}
                  onChange={(event) => selectOnChange(event, "PreRequisite")}
                />
                <p style={{ color: "red" }}>
                  {ModalFormErrors["preRequisite_isEmpty"]}
                </p>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="form-group">
                <label>
                  Description <sup>*</sup>
                </label>
                <InputForm
                  isDisabled={false}
                  placeholder={""}
                  textArea={true}
                  value={Description}
                  rows={3}
                  onChange={(event) => selectOnChange(event, "Description")}
                />
                <p style={{ color: "red" }}>
                  {ModalFormErrors["description_isEmpty"]}
                </p>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="form-group">
                <label>
                  Expected Result <sup>*</sup>
                </label>
                <InputForm
                  isDisabled={false}
                  placeholder={""}
                  textArea={false}
                  value={ExpectedResult}
                  onChange={(event) => selectOnChange(event, "ExpectedResult")}
                />
                <p style={{ color: "red" }}>
                  {ModalFormErrors["expectedResult_isEmpty"]}
                </p>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="form-group">
                <label>Status</label>
                <SelectForm
                  options={StatusOptions}
                  placeholder="Select"
                  isDisabled={true}
                  value={TestCaseStatus}
                  onChange={(event) => selectOnChange(event, "status")}
                  isMulti={false}
                  noIndicator={false}
                  noSeparator={false}
                />
              </div>
            </div>
            <div className="col-lg-12">
              <div className="form-group">
                <label htmlFor="isActive" className="mr-2">
                  Is Active
                </label>
                <input
                  id="isActive"
                  type="checkbox"
                  onChange={(e) => setIsActive(e.target.checked)}
                  name="isActive"
                  checked={isActive}
                />
              </div>
            </div>
            <div className="col-lg-12">
              <div className="d-flex justify-content-end gap-2">
                <button
                  type="button"
                  onClick={() => handleClose()}
                  className="btn btn-reset"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-submit"
                  onClick={() => onClickFunction("submitModal")}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
export default TraceabilityTestCases;
// //Ankita
